// 教师端页面
import schoolLayout from "../pages/school/index.vue" // 教师端首页
import schoolResourceStudy from "../pages/school/resource/study/index.vue" // 实践资源库-学习资源
import schoolResourcePavilion from "../pages/school/resource/pavilion/index.vue" // 实践资源库-数字展馆
import schoolResourceBase from "../pages/school/resource/base/index.vue" // 实践资源库-实践基地
import schoolResourceQuestion from "../pages/school/resource/question/index.vue" // 实践资源库-试题资源
import statist from "../pages/school/statist/statist.vue" // 活动数据统计

import systemAdmin from "../pages/school/system/admin/index.vue" // 系统管理-管理员管理
import systemTeacher from "../pages/school/system/teacher/index.vue" // 系统管理-教师管理
import systemStudent from "../pages/school/system/student/index.vue" // 系统管理-学生管理
import schoolTeach from "../pages/school/teach/index.vue" // 实践教学活动
import teachCreate from "../pages/school/teach/create.vue" // 实践教学活动 - 创建活动
import activityLayout from "../pages/school/activity/index.vue" // 实践教学活动 - 活动管理首页
import activityManage from "../pages/school/activity/manage.vue" // 实践教学活动 - 活动管理列表
import activityClass from "../pages/school/activity/class.vue" // 实践教学活动 - 班级管理
import activityProgress from "../pages/school/activity/progress.vue" // 实践教学活动 - 活动管理 - 实践进度
import activityClassStudent from "../pages/school/activity/classStudent.vue" // 实践教学活动 - 活动管理 - 班级管理 - 班级学生
import activityDraw from "../pages/school/activity/draw.vue" // 实践教学活动 - 活动管理 - 绘云馆图谱
import activityUpload from "../pages/school/activity/upload.vue" // 实践教学活动 - 活动管理 - 传点位打卡
import activityCreate from "../pages/school/activity/create.vue" // 实践教学活动 - 活动管理 - 创实践微影
import activitySummary from "../pages/school/activity/summary.vue" // 实践教学活动 - 活动管理 - 实践成绩汇总
import activityDrawMark from "../pages/school/activity/drawMark.vue" // 实践教学活动 - 活动管理 - 绘云馆图谱 - 评分
import activityUploadwMark from "../pages/school/activity/uploadMark.vue" // 实践教学活动 - 活动管理 - 传点位打卡 - 评分
import activityCreatewMark from "../pages/school/activity/createMark.vue" // 实践教学活动 - 活动管理 - 传点位打卡 - 评分
import activityReport from "../pages/school/activity/report.vue" // 实践教学活动 - 活动管理 - 写实践报告
import activityReportMark from "../pages/school/activity/reportMark.vue" // 实践教学活动 - 活动管理 - 写实践报告 - 评分
import activityHall from "../pages/school/activity/hall.vue" // 实践教学活动 - 活动管理 - 讲展馆故事 - 浙江金融定制
import activityHallMark from "../pages/school/activity/hallMark.vue" // 实践教学活动 - 活动管理 - 讲展馆故事 - 评分  - 浙江金融定制
import activityAnalytics from "../pages/school/activity/analytics.vue" // 实践教学活动 - 活动管理 - 统计分析
import activityDownLoad from "../pages/school/activity/downLoad.vue" // 实践教学活动 - 活动管理 - 导出作业附件


import caseLedger from "../pages/school/case/ledger.vue" // 实践案例-案例台账
import caseExcellent from "../pages/school/case/excellent.vue" // 实践案例-优秀案例
import casePushForm from "../pages/school/case/casePushForm.vue" // 实践案例-案例台账-案例推优
import caseDownload from "../pages/school/case/downLoad.vue" //实践案例-优秀案例 - 导出视频附件


// 红色金融实践
import hsjrClass from "../pages/school/hsjr/class/hsjrClass.vue" // 红色金融实践 - 班级首页
import hsjrStudent from "../pages/school/hsjr/class/student.vue" // 红色金融实践 - 班级学生
import hsjrSubmitRes from "../pages/school/hsjr/class/submitRes.vue" // 红色金融实践 - 提交结果
import submited from "../pages/school/hsjr/class/submited.vue" // 红色金融实践 - 已提交结果
import unSubmitted from "../pages/school/hsjr/class/unSubmitted.vue" // 红色金融实践 - 未提交结果
import resReview from "../pages/school/hsjr/class/resReview.vue" // 红色金融实践 - 评阅
import hsjrDownload from "../pages/school/hsjr/class/download.vue" // 红色金融实践 - 评阅
import stadiumType from "../pages/school/hsjr/stadium-type/stadiumType.vue" // 红色金融实践 - 场馆类型
import stadiumAddress from "../pages/school/hsjr/stadium-address/stadiumAddress.vue" // 红色金融实践 - 场馆旧址
import artifact from "../pages/school/hsjr/stadium-address/artifact.vue" // 红色金融实践 - 文物
import character from "../pages/school/hsjr/stadium-address/character.vue" // 红色金融实践 - 人物
import showroom from "../pages/school/hsjr/stadium-address/showroom.vue" // 红色金融实践 - 线上展厅


// schoolRoutes 和 schoolMap 需要同步维护 否则会出现路由跳转错误
export const schoolRoutes = [
  {
    path: "/:schoolcode(\\d+)?/school",
    name: "教师端",
    component: schoolLayout,
    redirect: "/:schoolcode(\\d+)?/school/resource/study",
    children: [
      { path: "resource/study", name: "学习资源", component: schoolResourceStudy },
      { path: "resource/pavilion", name: "数字展馆", component: schoolResourcePavilion },
      { path: "resource/base", name: "实践基地", component: schoolResourceBase },
      { path: "resource/question", name: "试题资源", component: schoolResourceQuestion },
      { path: "teach", name: "实践教学活动", component: schoolTeach },
      { path: "teach/create", name: "实践教学活动 - 创建活动", component: teachCreate },
      { path: "system/admin", name: "管理员管理", component: systemAdmin },
      { path: "system/teacher", name: "教师管理", component: systemTeacher },
      { path: "system/student", name: "学生管理", component: systemStudent },
      { path: "case/ledger", name: "实践案例", component: caseLedger },
      { path: "case/excellent", name: "优秀案例", component: caseExcellent },
      { path: "case/casepushform", name: "案例推优", component: casePushForm },
      { path: "case/download", name: "导出视频", component: caseDownload },
      { path: "statist", name: "活动数据统计", component: statist },
      // 红色金融实践
      { path: "hsjr/class", name: "实践班级", component: hsjrClass, },
      { path: "hsjr/Student", name: "班级学生", component: hsjrStudent, },
      { path: "hsjr/download", name: "红色金融下载", component: hsjrDownload, },
      {
        path: "hsjr/SubmitRes", name: "提交结果", component: hsjrSubmitRes, redirect: "/:schoolcode(\\d+)?/school/hsjr/SubmitRes/submited",
        children: [
          { path: "submited", name: "已提交", component: submited, },
          { path: "unSubmitted", name: "未提交", component: unSubmitted, },
        ]
      },

      { path: "hsjr/resReview", name: "评阅", component: resReview, },
      { path: "hsjr/stadiumType", name: "场馆类型", component: stadiumType, },
      { path: "hsjr/stadiumAddress", name: "场馆旧址", component: stadiumAddress, },
      { path: "hsjr/artifact", name: "文物", component: artifact, },
      { path: "hsjr/character", name: "人物", component: character, },
      { path: "hsjr/showroom", name: "线上展厅", component: showroom, },
      {
        path: "activity",
        name: "实践教学活动管理",
        component: activityLayout,
        redirect: "/:schoolcode(\\d+)?/school/activity/manage",
        children: [
          { path: "manage", name: "活动管理", component: activityManage },
          { path: "class", name: "班级管理", component: activityClass },
          { path: 'class/student', name: '班级学生', component: activityClassStudent },
          { path: "progress", name: "实践进度", component: activityProgress },
          { path: "draw", name: "绘云馆图谱", component: activityDraw },
          { path: "upload", name: "传点位打卡", component: activityUpload },
          { path: "create", name: "创实践微影", component: activityCreate },
          { path: "draw/mark", name: "绘云馆图谱-批阅", component: activityDrawMark },
          { path: "upload/mark", name: "传点位打卡-批阅", component: activityUploadwMark },
          { path: "create/mark", name: "创实践微影-批阅", component: activityCreatewMark },
          { path: "report", name: "写实践报告", component: activityReport },
          { path: "report/mark", name: "写实践报告-批阅", component: activityReportMark },
          { path: "hall", name: "讲展馆故事", component: activityHall },
          { path: "hall/mark", name: "讲展馆故事-批阅", component: activityHallMark },
          { path: "summary", name: "实践成绩汇总", component: activitySummary },
          { path: "analytics", name: "统计分析", component: activityAnalytics },
          { path: "download", name: "导出作业附件", component: activityDownLoad },
        ]
      },

    ]
  }
]

// schoolRoutes 和 schoolMap 需要同步维护 否则会出现路由跳转错误
export const schoolMap = [
  '/school', "/school/resource/study", "/school/resource/pavilion", "/school/resource/base", '/school/resource/question', '/school/teach', '/school/system/admin', '/school/system/teacher', '/school/system/student',
  '/school/activity', '/school/activity/manage', '/school/activity/class', '/school/activity/class/student', '/school/activity/progress', '/school/activity/draw', '/school/activity/upload', '/school/teach/create',
  '/school/activity/report','/school/activity/report/mark',
  '/school/activity/hall','/school/activity/hall/mark',
  '/school/activity/draw/mark', '/school/activity/upload/mark', '/school/activity/create/mark', '/school/activity/summary', '/school/activity/create', '/school/activity/analytics', '/school/activity/download',
  '/school/case/ledger', '/school/case/excellent', '/school/case/casepushform', "/school/case/download", "/school/statist", "/school/hsjr/class", "/school/hsjr/Student", "/school/hsjr/SubmitRes", "/school/hsjr/SubmitRes/submited", "/school/hsjr/SubmitRes/unSubmitted", "/school/hsjr/resReview", "/school/hsjr/stadiumType", "/school/hsjr/stadiumAddress", "/school/hsjr/artifact", "/school/hsjr/character", "/school/hsjr/showroom","/school/hsjr/download"
]